import * as React from "react";

import { Chip } from "mpulse-design-system";

import MetadataStatus from "../../utils/enums/MetadataStatus";
import constants from "../../constants";

const MetadataStatusChip = ({ status }) => {
  return (
    <Chip
      label={constants.metadata.statuses[status]}
      type={
        status === MetadataStatus.PUBLISHED
          ? "success"
          : status === MetadataStatus.PENDING_VOICE_TALENT
          ? "warning"
          : status === MetadataStatus.READY_FOR_REVIEW
          ? "info"
          : "default"
      }
    />
  );
};

export default MetadataStatusChip;
